import {Injectable} from '@angular/core';
import {
  faBell,
  faBuilding, faBusinessTime, faCalendarDays, faCheck,
  faChevronDown,
  faChevronLeft, faChevronRight,
  faCircle, faClose, faEnvelope, faFilePdf, faFingerprint, faFolderTree,
  faGears,
  faHandHoldingHand, faHeadset,
  faList,
  faNewspaper,
  faPenToSquare, faPhone, faShop,
  faTrashCan, faTruck,
  faUser,
  faUserGroup,
  faUserShield, faUserTie,
  IconDefinition
} from "@fortawesome/free-solid-svg-icons";

@Injectable({
  providedIn: 'root'
})
export class FaIconService {

  faIcons: { name: string; definition: IconDefinition }[] = [
    {
      name: 'settings',
      definition: faGears
    },
    {
      name: 'report',
      definition: faNewspaper
    },
    {
      name: 'pdf',
      definition: faFilePdf
    },
    {
      name: 'service',
      definition: faHandHoldingHand
    },
    {
      name: 'user',
      definition: faUser
    },
    {
      name: 'arrow-down',
      definition: faChevronDown
    },
    {
      name: 'arrow-left',
      definition: faChevronLeft
    },
    {
      name: 'list',
      definition: faList
    },
    {
      name: 'edit',
      definition: faPenToSquare
    },
    {
      name: 'delete',
      definition: faTrashCan
    },
    {
      name: 'users',
      definition: faUserGroup
    },
    {
      name: 'roles',
      definition: faUserShield
    },
    {
      name: 'dot',
      definition: faCircle
    },
    {
      name: 'building',
      definition: faBuilding
    },
    {
      name: 'folder-tree',
      definition: faFolderTree
    },
    {
      name: 'headset',
      definition: faHeadset
    },
    {
      name: 'email',
      definition: faEnvelope
    },
    {
      name: 'phone',
      definition: faPhone
    },
    {
      name: 'fingerprint',
      definition: faFingerprint
    },
    {
      name: 'arrow-right',
      definition: faChevronRight
    },
    {
      name: 'kiosk',
      definition: faShop
    },
    {
      name: 'delivery',
      definition: faTruck
    },
    {
      name: 'supervisor',
      definition: faUserTie
    },
    {
      name: 'calendar',
      definition: faCalendarDays
    },
    {
      name: 'check',
      definition: faCheck
    },
    {
      name: 'business-time',
      definition: faBusinessTime
    },
    {
      name: 'close',
      definition: faClose
    },
    {
      name: 'chevron-left',
      definition: faChevronLeft
    },
    {
      name: 'chevron-right',
      definition: faChevronRight
    },
    {
      name: 'notification',
      definition: faBell
    },
    {
      name: 'user-tie',
      definition: faUserTie
    }
  ]

  constructor() { }
}
